import { IBreadcrumbStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, Sizes } from '../../themes/styles';

const height = 17;

export const breadcrumbStylesDefault = (theme: IH2OTheme): Partial<IBreadcrumbStyles> => ({
  root: {
    margin: 0,
    height,
  },
  listItem: {
    height,
    '.ms-Breadcrumb-itemLink': {
      textDecoration: 'none',
      color: theme.semanticColors?.textSecondary,
    },
  },
  chevron: {
    color: theme.semanticColors?.textSecondary,
    fontSize: FontSizes.xxxsmall,
    paddingLeft: '4px',
    paddingRight: '4px',
  },
  overflowButton: {
    height,
    lineHeight: height,
    fontSize: `${FontSizes.xsmall}px !important`, // ignore fluent media query
    borderRadius: Sizes.borderRadius,
    backgroundColor: theme.palette?.gray300,
    padding: '0 5px',
    ':hover': {
      backgroundColor: theme.palette?.gray300,
    },
  },
  itemLink: {
    lineHeight: height,
    fontSize: FontSizes.xsmall,
    borderWidth: 0,
    padding: 0,
  },
  item: {
    color: theme.semanticColors?.textSecondary,
    fontSize: FontSizes.xsmall,
    padding: 0,
  },
});
